<template>

      <div class="informacoes-adicionais__content">
        <h4>{{informativo.titulo}}</h4>
        <p
          v-for="(paragrafo, index) in informativo.paragrafos"
          :key="index"
          :class="[{ 'informacoes-adicionais__content__hidden': index > 0 && !isActive}]"
          v-html="paragrafo.texto"
        />


        <a  :class="['icon', { 'icon-close': isActive}]" @click="toggle()" v-if="informativo.paragrafos.length > 1">
          {{isActive ? 'Fechar' : 'Leia mais'}}
        </a>
      </div>

</template>
<script>

export default {
  components: {

  },

  data() {
    return {
      isActive: false
    }
  },
  props: {
    informativo: {
      type: Object,
      required: true,
      default: () => {},
    }
  },
  methods: {
    toggle() {
      this.isActive = !this.isActive;
    },

    formatarParagrafos(paragrafos) {
      const paragrafoFormat = []
      paragrafos.forEach(paragrafo => {
        let text = paragrafo.texto
        paragrafo.links.forEach(link => {
          text = text.replace(`{${link.id}}`, `<a class="content-link" href="${link.url}">${link.descricao}</a>`)
        });
        paragrafo.texto = text;
        paragrafoFormat.push(paragrafo)

      });
      return paragrafoFormat
    }
  },
  mounted() {
    this.formatarParagrafos(this.informativo.paragrafos)
  },
}

</script>

<style lang="scss" src="./ToggleListItem.styles.scss" scoped></style>

